import { defineMessages } from "react-intl";
export default defineMessages({
  welcomeTitle: {
    "id": "intro.welcomeTitle",
    "defaultMessage": "Your Weather, Reimagined"
  },
  welcomeDescription: {
    "id": "intro.welcomeDescription",
    "defaultMessage": "Get hyperlocal forecasts powered by top weather agencies — plus access to 40,000+ weather stations worldwide to see real-world conditions, past and present."
  },
  locationTitle: {
    "id": "intro.locationTitle",
    "defaultMessage": "Forecasts Made for You"
  },
  locationDescription: {
    "id": "intro.locationDescription",
    "defaultMessage": "Enable location access to get accurate weather predictions tailored to your exact area — no more one-size-fits-all forecasts."
  },
  notificationsTitle: {
    "id": "intro.notificationsTitle",
    "defaultMessage": "Never Miss a Weather Shift"
  },
  notificationDescription: {
    "id": "intro.notificationDescription",
    "defaultMessage": "Turn on notifications to get timely alerts about weather changes that matter to you — rain, snow, or severe conditions, right when you need to know."
  },
  readyTitle: {
    "id": "intro.readyTitle",
    "defaultMessage": "You're All Set!"
  },
  readyDescription: {
    "id": "intro.readyDescription",
    "defaultMessage": "Enjoy precise forecasts, real-time weather insights, and station data from around the globe — all in one powerful app."
  }
});